exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rotate {\n  transform: rotate(90deg);\n}\n\n/**\n * Styles pour le pseudo HTML \n * représentant l'agent et son avatar dans le widget\n */\n.widget-latin--open {\n  position: absolute;\n  width: 257px;\n  margin-left: 25px;\n  margin-top: 21px;\n  display: -ms-flexbox;\n  display: flex;\n}\n.widget-latin--open__agent {\n  margin-left: 5px;\n  margin-top: 3px;\n}\n.widget-latin--open__agent-job {\n  font-style: italic;\n}\n.widget-latin--close {\n  position: absolute;\n  width: 300px;\n  margin-left: 65px;\n  margin-top: 15px;\n}\n.widget-latin--close.rotate {\n  margin-top: 217px;\n  margin-left: -102px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/Preview.vue
// module id = vZVr
// module chunks = 1